import React, { useEffect, useCallback, useRef} from 'react';
import { useHistory, useParams, } from 'react-router-dom';
import { useFirebaseStorage } from 'utils/hooks/useFirebaseStorage';
import { TextField as MatTextField } from '@material-ui/core';
import { Select, PhoneForm, Form, Button, Modal,AvatarUpload, ContactInput } from 'components';
import { useCustomer } from 'store/customer';
import { useUser } from 'store/user';
import { useSetState } from 'utils/hooks/useSetState';
import { emailReg, phoneNumberValid, taiwanPhoneValid } from 'utils/validation';
import { EDIT_STATUS, ORGANIZATION_SETTINGS_VALUE, PHONE_LENGTH_NOT_INCLUDE_COUNTY_CODE } from 'constants/index';
import { useAlert } from 'utils/hooks/useAlert';
import {
  UiCustomerForm,
  UiCustomerButtonBox,
  UiFormBox,
  UiFormText,
} from './CustomerForm.style';
import { getCustomer as getCustomerApi } from 'services/api/organization/customer';

/**
 * 邀請學生Form
 */

const CUSTOMER_KEY = {
  USERID: 'userId',
  EMAIL: 'email',
  MOBILE_NUMBER: 'mobileNumber',
  CARDID: 'punchCardId'
};



export const CustomerForm = ({ editStatus }) => {
  const prevFormValue = useRef({});
  const [{
    data,
    isLoading,
    selectOption,
    blackList,
    isCreating,
    modalState,
    imgUrl,
  }, setState] = useSetState({
    data: null,
    isLoading: editStatus === EDIT_STATUS.CREATE ? false : true,
    selectOption: CUSTOMER_KEY.USERID,
    blackList: [],
    isCreating: editStatus === EDIT_STATUS.CREATE,
    modalState: false,
    imgUrl:'',
  });
  const history = useHistory();
  const { upload } = useFirebaseStorage();
  const { setAlert } = useAlert();
  const { organizationId, customerId } = useParams();
  const [{myOrganization}, { changeUserRole }] = useUser();
  const [
    { customer },
    { inviteCustomers, getCustomer, updateCustomer }
  ] = useCustomer();

  const hasExamReportedLineNotifySetting = myOrganization.organization.organizationExamReportedLineNotifySetting === ORGANIZATION_SETTINGS_VALUE.ENABLED;

  const checkPhone = (value) => {
    if(value) {
      if(value.mobile) {
        if(!phoneNumberValid(value.mobile) && !taiwanPhoneValid(value.mobile)) {
          return 'mobile::電話格式錯誤';
        }
        if(!value.relation) {
          return 'relation::缺少關係';
        }
      }
    }

    return ;
  };

  const changeRelation = value => {
    if(value[0] || value[1]) {
      return {
        relation: value[0],
        mobile: value[1]
      };
    } else {
      return null;
    }
  };

  const showCardFunc = () => {
    return myOrganization.organization.punchClockSetting === 'enabled';
  };

  const schema = {
    [CUSTOMER_KEY.USERID]: {
      component: MatTextField,
      elementProps: {
        label: '學生 id',
        value: '',
        helperText: ''
      },
      rules: {
        required: {
          value: true,
          message: '本欄位為必填',
        },
      },
    },
    [CUSTOMER_KEY.EMAIL]: {
      component: MatTextField,
      elementProps: {
        label: 'email',
        value: '',
        helperText: '',
      },
      rules: {
        required: {
          value: true,
          message: '本欄位為必填'
        },
        pattern: {
          value: emailReg,
          message: 'mail 格式錯誤',
        }
      }
    },
    [CUSTOMER_KEY.MOBILE_NUMBER]: {
      component: PhoneForm,
      elementProps: {
        label: '緊急聯絡電話',
        defaultPhoneNum: '',
        defaultCountryNum: '',
        helperText: '',
        onChange: n => {
          if (n[1]) {
            return (n[0] + n[1]);
          }
          return null;
        }
      },
      rules: {
        required: {
          value: true,
          message: '本欄位為必填'
        },
        validate: value => {
          if (!value) return;
          return phoneNumberValid(value) || '電話格式錯誤';
        }
      }
    },
    nickname: {
      component: MatTextField,
      elementProps: {
        label: '機構暱稱',
        value: '',
        helperText: ''
      },
      rules: {
        required: {
          value: true,
          message: '本欄位為必填',
        }
      },
    },
    [CUSTOMER_KEY.CARDID]: {
      component: MatTextField,
      elementProps: {
        label: '刷卡卡號',
        value: '',
        needHide: !showCardFunc()
      },
      rules: {
        validate: value => {

          if (!value || (!isNaN(value) && value.length === 10)) return;
          return '格式須為10碼數字';
        }
      },
    },
    ...hasExamReportedLineNotifySetting && {
      contact1: {
        component: ContactInput,
        elementProps: {
          needHide : !showCardFunc(),
          showTitle: true,
          isShowLineNotify: true,
          onChange: changeRelation,
          inputIndex: 0,
        }, rules: {
          validate: checkPhone
        },
      },
      contact2: {
        component: ContactInput,
        elementProps: {
          needHide : !showCardFunc(),
          showTitle: false,
          isShowLineNotify: true,
          onChange: changeRelation,
          inputIndex: 1,
        }, rules: {
          validate: checkPhone
        },
      },
      contact3: {
        component: ContactInput,
        elementProps: {
          needHide : !showCardFunc(),
          showTitle: false,
          isShowLineNotify: true,
          onChange: changeRelation,
          inputIndex: 2,
        }, rules: {
          validate: checkPhone
        },
      },
      contact4: {
        component: ContactInput,
        elementProps: {
          needHide : !showCardFunc(),
          showTitle: false,
          isShowLineNotify: true,
          onChange: changeRelation,
          inputIndex: 3,
        }, rules: {
          validate: checkPhone
        },
      },
    }
  };

  const buttons = [
    {
      text: '確認',
      type: 'submit'
    },
    {
      text: '回到上一頁',
      color: 'info',
      icon: 'exitToApp',
      func: () => { history.push(`/organization/${organizationId}/customer`); }
    }
  ];

  const selectProps = {
    label: '註冊方式',
    options: [
      {
        name: '學生 id',
        value: CUSTOMER_KEY.USERID
      },
      {
        name: '手機號碼',
        value: CUSTOMER_KEY.MOBILE_NUMBER
      },
      {
        name: 'email',
        value: CUSTOMER_KEY.EMAIL
      }
    ],
    submitHandler: value => {
      setState({ selectOption: value });
    }
  };

    // 上傳檔案
    const onUploaded = async file => {//編輯才有上傳圖片
      const enCodeCustomerId = encodeURIComponent(customerId).replace('.', '');
      const fileType = file.type.split('/')[1];
      const uploadPath = `${organizationId}/customerAvatars/${enCodeCustomerId}.${fileType}`;
      const { status, url } = await upload(uploadPath, file);

      if (status) {
        setState({ imgUrl: url });
        setAlert('上傳成功!', 'success');
      } else {
        setAlert('上傳失敗!', 'warning');
      }
    };

  /* 檢查表單上的 line 電話號碼與原本的電話號碼是否不一樣 */
  const checkContactsNotEquality = (formData, apiData) => {
    const isNotEquality = formData.contacts.some((contact, i) => {
      // 表單上的手機號碼長度
      const formContactMobileLength = contact.mobile.length;
      const formContactMobile = contact?.mobile.substring(formContactMobileLength - PHONE_LENGTH_NOT_INCLUDE_COUNTY_CODE, formContactMobileLength);

      // api 上的手機號碼長度
      const apiDataContactMobileLength = apiData?.contacts?.[i]?.mobile.length;
      const apiDataContactMobile = apiData?.contacts?.[i]?.mobile.substring(apiDataContactMobileLength - PHONE_LENGTH_NOT_INCLUDE_COUNTY_CODE, apiDataContactMobileLength);

      // 是否不一樣
      const isNotEquality = formContactMobile !== apiDataContactMobile;
      return isNotEquality;
    });
    return isNotEquality;
  };

  const submitFormHandler = async data => {

    if (editStatus === EDIT_STATUS.READ) {
      history.push(`/organization/${organizationId}/customer`);
    }
    setState({ isLoading: true });
    let isSuccess;
    // 新增
    if (editStatus === EDIT_STATUS.CREATE) {
      const { nickname } = data;
      isSuccess = await inviteCustomers({
        customer:
          {
            [selectOption]: data[selectOption],
            nickname
          }
      });
    }

    // 編輯
    if (editStatus === EDIT_STATUS.EDIT) {
      let isValidNumber = false;
      let isValidEmail = false;

      if (data.mobileNumber) {
        isValidNumber = phoneNumberValid('+' + data.mobileNumber);
        if (!isValidNumber) {
          setAlert('電話格式錯誤', 'error');
          setState({ isLoading: false });
          return;
        }
      }

      if (data.email) {
        isValidEmail = emailReg.test(data.email);
        if (!isValidEmail) {
          setAlert('mail格式錯誤', 'error');
          setState({ isLoading: false });
          return;
        }
      } else {
        delete data.email;
      }
      const formData = {
        contacts: []
      };

      if (data.email) formData.email = data.email;
      if (data.mobileNumber) formData.mobileNumber = data.mobileNumber;
      if (data.nickname) formData.nickname = data.nickname;
      if (data.punchCardId) formData.punchCardId = data.punchCardId;
      if (data.contact1) formData.contacts = formData.contacts.concat(data.contact1);
      if (data.contact2) formData.contacts = formData.contacts.concat(data.contact2);
      if (data.contact3) formData.contacts = formData.contacts.concat(data.contact3);
      if (data.contact4) formData.contacts = formData.contacts.concat(data.contact4);

      const nextData = data && Object.assign(formData, { thumbnailUrl: imgUrl });
      const customerApiData = await getCustomerApi(organizationId, customerId)();

      isSuccess = await updateCustomer(nextData);
      if (isSuccess) {
        const isNotContactsEquality = checkContactsNotEquality(formData, customerApiData.data);
        isNotContactsEquality && setAlert('您已成功發送綁定簡訊！', 'success');
      }
    }

    setState({ isLoading: false });
    if (isSuccess) history.push(`/organization/${organizationId}/customer`);
  };

  useEffect(() => {
    let nextBlackList = [];

    if (!isCreating) {
      setState({ blackList: nextBlackList });
      return;
    }

    switch (selectOption) {
      case CUSTOMER_KEY.USERID:
        nextBlackList = [CUSTOMER_KEY.EMAIL, CUSTOMER_KEY.MOBILE_NUMBER];
        break;
      case CUSTOMER_KEY.EMAIL:
        nextBlackList = [CUSTOMER_KEY.USERID, CUSTOMER_KEY.MOBILE_NUMBER];
        break;
      case CUSTOMER_KEY.MOBILE_NUMBER:
        nextBlackList = [CUSTOMER_KEY.USERID, CUSTOMER_KEY.EMAIL];
        break;
      default:
        break;
    }

    setState({ blackList: nextBlackList });
  }, [selectOption]);

  /* 邀請學生，設定比對資料用的 prev  */
  const setPrevFormValueToCreate = () => {
    // 清空 prevFormValue
    for(const key in prevFormValue.current) delete prevFormValue.current[key];

    // 設定 prevFormValue
    prevFormValue.current['nickname'] = null;
    switch (selectOption){
      case CUSTOMER_KEY.USERID:
        prevFormValue.current[CUSTOMER_KEY.USERID] = null;
        break;
      case CUSTOMER_KEY.MOBILE_NUMBER:
        prevFormValue.current[CUSTOMER_KEY.MOBILE_NUMBER] = null;
        break;
      case CUSTOMER_KEY.EMAIL:
        prevFormValue.current[CUSTOMER_KEY.EMAIL] = null;
        break;
      default:
        break;
    }
  };

  const nextData = useCallback(() => {
    // 不可被編輯的欄位
    const blackList = [CUSTOMER_KEY.USERID,'originalName','originalNickname'];
    let isRead = false;
    // 根據網址狀態判斷
    switch (editStatus) {
      // 編輯
      case EDIT_STATUS.EDIT:
        if (!customer) return;
        break;
      // 檢視
      case EDIT_STATUS.READ:
        isRead = true;
        if (!customer) return;
        break;
      case EDIT_STATUS.CREATE:
      default:
        setPrevFormValueToCreate(); // prev 比對資料用初始值設
        return schema;
    }

    // schema 比對
    const newData = Object.assign({}, schema);
    Object.entries(newData).forEach(([key]) => {

      if (!customer['email']) {
        delete newData['email'].rules;
      }

      if (!customer['mobileNumber']) {
        delete newData['mobileNumber'].rules;
      }
      if (key === CUSTOMER_KEY.USERID) {
        newData[key].elementProps.defaultValue = customer['id'];
        prevFormValue.current[key] = customer['id'];
      } else if(key.includes('contact')) {

        if(showCardFunc()) {
          const last = key.charAt(key.length - 1);
          if(customer['contacts'][last-1]) {
            newData[key].elementProps.defaultObject = customer['contacts'][last - 1];
            const newContact = { ...customer['contacts'][last - 1] };
            delete customer['contacts'][last - 1];
            prevFormValue.current[key] = newContact;
          } else {
            prevFormValue.current[key] = null;
          }
        }

      } else if(key === CUSTOMER_KEY.CARDID) {

        if(showCardFunc()) {
          newData[key].elementProps.defaultValue = customer[key];
          if(customer[key] === '') {
            prevFormValue.current[key] = null;
          } else {
            prevFormValue.current[key] = customer[key] ?? null;
          }
        }

      } else {
        newData[key].elementProps.defaultValue = customer[key];
        prevFormValue.current[key] = customer[key] ?? null;
      }

      if (editStatus === EDIT_STATUS.READ) {
        newData[key].elementProps.disabled = isRead;
      } else {
        newData[key].elementProps.disabled = blackList.includes(key) ? !isRead : isRead;
      }
    });
    return newData;
  }, [data, editStatus, schema, customer]);

  //Modal buttons
  const modalButtons = [
    {
      text: '確認',
      func: async () => {
        await changeUserRole().then(isSuccess => {
          isSuccess && history.push(`/organization/${organizationId}/teachers`);
        });
      }
    },
    {
      text: '取消',
      color: 'highlight',
      func: () => { }
    }
  ];

  const openModal = () => {
    setState({
      modalState: true
    });
  };

  const getModalStateHandler = state => {
    setState({
      modalState: state
    });
  };

  const fetchData = async () => {
    const res = await getCustomer();
    setState({ isLoading: false,imgUrl: res?.thumbnailUrl });
  };

  useEffect(() => {
    if (!customerId) return;
    fetchData();
  }, [customerId]);

  return (
    <UiCustomerForm>
      <UiCustomerButtonBox>
        <Button onClick={openModal}>修改權限為教師</Button>
      </UiCustomerButtonBox>
      {
        isCreating && (
          <Select
            label={selectProps.label}
            value={selectOption}
            options={selectProps.options}
            submitHandler={selectProps.submitHandler}
          />
        )
      }
      {(editStatus !== EDIT_STATUS.CREATE) &&
        <AvatarUpload
          imgUrl={imgUrl}
          onUploaded={onUploaded}
          disabled={
            myOrganization.organization.customerProfileOriginSetting === ORGANIZATION_SETTINGS_VALUE.DEFAULT
            || editStatus === EDIT_STATUS.READ
          }
        />
      }
      <UiFormBox>
        {
          editStatus !== EDIT_STATUS.CREATE && <>
            <UiFormText>姓名: {customer?.originalName}</UiFormText>
            <UiFormText>暱稱: {customer?.originalNickname}</UiFormText>
          </>
        }
        <Form
          schema={!isLoading ? nextData() : {}}
          isLoading={isLoading}
          buttons={buttons}
          blackList={blackList}
          onSubmit={submitFormHandler}
          prevFormValue={prevFormValue}
          editStatus={editStatus}
          needHide={true}
        />
      </UiFormBox>
      <Modal
        isOpen={modalState}
        text="確定要修改此使用者權限為教師"
        buttons={modalButtons}
        getModalState={getModalStateHandler}
      />
    </UiCustomerForm>
  );
};
